<template>
	<v-dialog
		v-model="visible"
		max-width="400"
		persistent
	>
		<v-alert
			class="dialog mb-0"
			border="top"
			colored-border
			:color="type"
		>
			<div class="title-text">
				<v-icon v-if="icon.length !== 0" :color="type" class="mr-2">{{ icon }}</v-icon>
				{{ title_text }}
			</div>
			<div class="content-text">{{ content_text }}</div>
			<div class="button">
				<div class="button-left" @click="$emit('cancel')">{{ cancel_button }}</div>
				<div class="button-right" @click="$emit('ok')">{{ confirm_button }}</div>
			</div>
		</v-alert>
	</v-dialog>
</template>

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title_text: {
			type: String,
			default: ''
		},
		content_text: {
			type: String,
			default: ''
		},
		confirm_button: {
			type: String,
			default: 'Confirm'
		},
		cancel_button: {
			type: String,
			default: 'Cancel'
		},
		type: {
			/*  info: blue, error: red, warning: yellow */
			type: String,
			default: 'info'
		},
		icon: {
			type: String,
			default: ''
		}
	},
	data() {
		return {}
	},
}	
</script>

<style lang="scss" scoped>
.dialog {
	padding: 20px 40px;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
	line-height: 20px;
  color: #000000;
  margin: 15px 0;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-left {
	border: 1px solid rgba(25, 42, 62, 0.7);
	border-radius: 4px;
	color: rgba(25, 42, 62, 0.7);
	padding: 0 16px;
	margin-right: 16px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 30px;
	&:hover {
		cursor: pointer;
	}
}
.button-right {
	border: 1px solid #00AAFD;
	border-radius: 4px;
	background: #00AAFD;
	color: #FFFFFF;
	padding: 0 16px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 30px;
	&:hover {
		cursor: pointer;
	}
}

</style>

